import { Routes } from '@angular/router';
import { AuthGuard } from '@core/auth/guards/auth.guard';

export const SLAUGHTER_LIST_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./slaughter-list.component').then(m => m.SlaughterListComponent),
    canActivate: [AuthGuard],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./slaughter-list-detail/slaughter-list-detail.component').then(m => m.SlaughterListDetailComponent),
    canActivate: [AuthGuard],
  }
];
